import { useEffect, useState } from 'react'
import './cookiealert.css'
import AppInfo from '@qiyo_components/AppInfo'
// https://www.geeksforgeeks.org/how-to-install-and-use-react-bootstrap-with-gatsby-js/
import { Container, Navbar, Nav, Button } from 'react-bootstrap'

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined"

// https://github.com/Wruczek/Bootstrap-Cookie-Alert
// Cookie functions from w3schools
export function setCookie(
  cname: string,
  cvalue: string | boolean,
  exdays: number
) {
  if (!isBrowser)
      return;

  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string): string {
  if (!isBrowser)
    return '';

  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function isCookieConfirmed(): boolean {
  if (!isBrowser)
    return false;

  var cookieValue = getCookie('acceptCookies')
  // console.log('CookieAlert-2: cookieValue=', cookieValue)

  return cookieValue === 'true'
}

const CookieAlert = () => {
  if (!isBrowser)
    return;
  
  const [show, setShow] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 3000)
  }, [])

  var cookieAlert = document.querySelector('.cookiealert')
  var acceptCookies = document.querySelector('.acceptcookies')

  // console.log('CookieAlert-1: cookieAlert=', cookieAlert, ', show=', show, ', cookie=', getCookie("acceptCookies"))

  // console.log('CookieAlert-1: acceptCookies=', acceptCookies)

//   setCookie('acceptCookies', false, 365)

  // console.log('CookieAlert-1-2')

  // cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  if (show) {
    // var cookieValue = getCookie("acceptCookies")
    // // console.log('CookieAlert-2: cookieValue=', cookieValue)

    // // Show the alert if we cant find the "acceptCookies" cookie
    // if (!cookieValue || cookieValue === "false") {
    //     // console.log('CookieAlert-2-1')
    //     if (cookieAlert) {
    //         cookieAlert.classList.add("show");
    //     }
    // }

    if (!isCookieConfirmed() && cookieAlert) {
      cookieAlert.classList.add('show')
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptCookies &&
      acceptCookies.addEventListener('click', function () {
        setCookie('acceptCookies', true, 365)
        // setCookie('acceptCookies', true, 1)
        cookieAlert && cookieAlert.classList.remove('show')

        // dispatch the accept event
        window.dispatchEvent(new Event('cookieAlertAccept'))
      })
  }

  return (
    // <div className="d-flex d-lg-block flex-column bg-dark text-light text-center rounded-0 cookiealert py-5 fs-2" >
    // 本網站運用 Cookie 技術以提供您更佳的個人化瀏覽體驗，如果您持續使用本網站，代表您已同意使用。
    // <a className="fw-bold text-hover-primary mx-3" href={`${AppInfo.baseName}legal/privacy`} target='_blank' rel="noreferrer">
    //     詳閱《隱私權政策》
    // </a>
    //  <h1>Welcome to My Website using Gatsby and React Boostrap</h1>

    //     <button type="button" className="btn btn-primary d-inline mx-auto ms-lg-5 acceptcookies mt-5 mt-lg-0 fs-2">
    //         我同意
    //     </button>
    // </div >

    // 我們紀錄 cookie 資訊，以提供客製化內容，可優化您的使用體驗，若繼續閱覽本網站內容，即表示您同意我們使用 cookies。更多關於隱私保護資訊，請閱覽我們的隱私權保護政策。

    <div className='banner cookiealert'>
      <Container className='container'>
        本網站運用 Cookie
        技術以提供您更佳的個人化瀏覽體驗，如果您持續使用本網站，代表您已同意使用。
        <a
          className='fw-bold text-hover-primary mx-3'
          href={`${AppInfo.baseName}legal/privacy`}
          target='_blank'
          rel='noreferrer'
        >
          詳閱《隱私權政策》
        </a>
        <Button variant='primary' className='acceptcookies'>
          我同意
        </Button>
      </Container>
    </div>
  )
}

export default CookieAlert
